import effectManager from '../module/effect';

let effect = new effectManager();

/* ---------------------------------------

    -- メインビジュアル内 webGL以外はここ

--------------------------------------- */
export default class MainvisualManager {
    constructor() {

        this.$play = $("#p-kv-content-play");
        this.$playCircle = $("#p-kv-content-play-icon-circle,#p-kv-content-play-icon-circle-light__inner");
        this.$playCircleLight = $("#p-kv-content-play-icon-circle-light img");
        this.$playCircleLightWrap = $("#p-kv-content-play-icon-circle-light");
        this.$playCircleHover = $("#p-kv-content-play-icon-circle-hover,#p-kv-content-play-icon-triangle-hover");


        this.status = {
            flg : false,
            out : true,
            timer:"",
            show:{
                timer1:"",
                timer2:""
            }
        }

    }
    init(){

        // TweenMax.set($("#p-kv-content-copy"),{"transform-style":"preserve-3d","perspective":10});
        this.playBtn("set");
        if(Useragnt.mobile) effect.show($("#l-scrolldown"),"set");
        TweenMax.set(this.$playCircleLight,{opacity:1,scale:1,y:10,x:10})

        // setTimeout(()=>{
        //     this.show();
        // },2e3)


        this.$play.hover(()=>{
            this.playBtn("mouseon");
            effect.btn(this.$play,"show","on");
        },()=>{
            this.playBtn("mouseout");
            effect.btn(this.$play,"out","out");
        });


    }

    show(){
        this.status.flg = true;
        effect.svg($("#p-kv .js__svg"),"show");
        this.status.show.timer1 = setTimeout(()=>this.playBtn("show"),1e3);
        this.status.show.timer2 = setTimeout(()=>{
            effect.splitText($("#p-kv-text >* >*"),"show")
            if(Useragnt.mobile) effect.show($("#l-scrolldown"),"show");
        },13e2);

    }
    out(){
        this.status.flg = false;
        this.playBtn("out");
        TweenMax.killTweensOf($("#p-kv .js__svg .js__svg-write,#p-kv-text >* >*"));
        clearTimeout(this.status.show.timer1);
        clearTimeout(this.status.show.timer2);
        // TweenMax.killChildTweensOf($("#p-kv,#p-kv-text"));
        effect.svg($("#p-kv .js__svg"),"out");
        effect.splitText($("#p-kv-text >* >*"),"out");
        if(Useragnt.mobile) effect.show($("#l-scrolldown"),"out");

    }
    playBtn(type){

        switch (type){
            case "set" :
                TweenMax.set(this.$play,{"transform-style":"preserve-3d","perspective":10});
                TweenMax.set(this.$play.children(),{opacity:0,z:-1});
                // TweenMax.set(this.$playCircleLightWrap,{opacity:0,z:-1});
                effect.btn(this.$play,"set");
                break;
            case "show" :

                this.status.out = false;

                this.playBtn("mouseout");
                effect.btn(this.$play,"out","out");

                TweenMax.to(this.$play.children(),0.4,{
                    opacity:1,
                    z:0,
                });
                // TweenMax.to(this.$playCircleLightWrap,0.4, {
                //     opacity: 1,
                //     z: 1,
                // });

                TweenMax.fromTo(this.$playCircle,2,
                    {
                        rotation:0,
                    },
                    {
                        rotation:360,
                        repeat:-1,
                        ease:Power0.easeNone
                    // repeatDelay:0.5,
                    // ease: Sine.easeInOut
                    // ease: Expo.easeInOut
                    }
                );
                TweenMax.fromTo(this.$playCircle,1,{
                  opacity : 1
                },{
                    opacity:0.3,
                    repeat:-1,
                    yoyo:true,
                    ease: Sine.easeInOut
                    // ease: Expo.easeInOut
                });


                // TweenMax.to(this.$playCircleLight,1,{
                //     y:0,
                //     x:0,
                //     opacity:0,
                //     scale  :0.8,
                //     // delay:2,
                //     repeat:-1,
                //     // repeatDelay:0.1,
                //     yoyo:true,
                //     ease: Sine.easeInOut
                //     // ease: Expo.easeInOut
                // });

                break;
            case "out" :

                this.status.out = true;

                TweenMax.killTweensOf(this.$play.children());
                TweenMax.killTweensOf(this.$playCircleLightWrap);
                // TweenMax.to(this.$playCircleLightWrap,0.4, {
                //     opacity: 0,
                //     z: -1,
                // });
                TweenMax.to(this.$play.children(),0.4,{
                    opacity:0,
                    z:-1,
                    onComplete:()=>{
                        TweenMax.killTweensOf(this.$playCircle);
                        // this.$playCircle.attr("style","")
                        TweenMax.killTweensOf(this.$playCircleLight);
                        // this.$playCircleLight.attr("style","")
                    }
                });
                break;
            case "mouseon" :

                if(this.status.out) return;

                // TweenMax.to(this.$playCircleLightWrap,0.4, {
                //     opacity: 0,
                //     z:-1
                // });
                TweenMax.to(this.$playCircleHover,0.4, {
                    opacity: 1,
                });
                break;
            case "mouseout" :

                if(this.status.out) return;

                TweenMax.killTweensOf(this.$playCircleLightWrap);
                TweenMax.killTweensOf(this.$playCircleHover);
                // TweenMax.to(this.$playCircleLightWrap,0.4, {
                //     opacity: 1,
                //     z:0
                // });
                TweenMax.to(this.$playCircleHover,0.4, {
                    opacity: 0,
                });
                break;
        }


    }
    render(mouse,scrollInc){

    }
    resize(){

    }
}